export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('cpp:data:loaded', ({ type }) => {
    const isAutorefresh = +localStorage.getItem('autoPageRefresh');
    const refreshTimeInMinutes = +useRuntimeConfig().public?.autoRefresh?.route?.[type] || +useRuntimeConfig().public?.autoRefresh?.route?.default || 0;
    if (isAutorefresh && !!useRuntimeConfig().public?.autoRefresh?.mbl) {
      window.mblMeta = window.mblMeta || {};
      window.mblMeta.autorefresh = 1;
      localStorage.removeItem('autoPageRefresh');
    }
    if (refreshTimeInMinutes) {
      setTimeout(() => {
        localStorage.setItem('autoPageRefresh', '1');
        window.location.reload();
      }, refreshTimeInMinutes * 60 * 1000);
    }
  });
});
